import { Empty } from "../shared/Empty";
import { getCandidateTitle } from "./CandidateAPI";

export const CandidateTitle = ({ candidateDetails }) => {
  return getCandidateTitle(candidateDetails) || <Empty />;
};
